module.exports = __webpack_public_path__ + "img/BLancer64_ua.cd398d13.webp";